import { CreateNewCombo } from "dmcMaster/combo/CreateNewCombo";
import React from "react";
import ActivityComboCard from "./components/ActivityComboCard";

function ActivityCombo() {
  const [showCombos, setShowCombos] = React.useState(false);
  const toggleCombos = () => setShowCombos(!showCombos);
  return (
    <main className="my-4">
      <section className="d-flex justify-content-between align-items-center container">
        <h1 className="text-center">Manage Combos</h1>
        <button onClick={toggleCombos} className="btn btn-primary btn-flat">
          + Create Combo
        </button>
      </section>
      <ActivityComboCard />
      {showCombos && (
        <CreateNewCombo
          comboId={0}
          isModalOpen={showCombos}
          handleModalClose={toggleCombos}
        />
      )}
    </main>
  );
}

export default ActivityCombo;
